import React, { useEffect, useState } from "react";
import { getCurrentUser, signOut, AuthUser } from "aws-amplify/auth";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

const SignOut = () => {
  const [user, setUser] = useState<AuthUser | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const authUser = await getCurrentUser();
        setUser(authUser);
      } catch (error) {
        console.log("Error fetching user:", error);
      }
    };

    fetchUser();
  }, []);

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate("/");
    } catch (error) {
      console.log("Error signing out: ", error);
    }
  };

  return (
    <div>
      <div>
        {user ? (
          <div>
            <Link to="#" onClick={handleSignOut}>
              Sign out
            </Link>
          </div>
        ) : (
          <div>User not signed in</div>
        )}
      </div>
    </div>
  );
};

export default SignOut;
